import Flickity from "flickity";

const initProductGallery = () => {
  setTimeout(() => {
  const galleryProduct = document.querySelector('.woocommerce-product-gallery .flex-control-nav.flex-control-thumbs')

    if (!galleryProduct) {
      return;
    }

  const galleryProductInst = new Flickity('.woocommerce-product-gallery .flex-control-nav.flex-control-thumbs', {
    cellAlign: 'left',
    contain: true,
    imagesLoaded: true,
    pageDots: true,
    adaptiveHeight: true,
    prevNextButtons: false,
    draggable: true,
    groupCells: 2
  })
  }, 2000)
}

const initProductGalleryPhotoSwipe = () => {
  const galleryWrapper = document.querySelector('.woocommerce-product-gallery');
  
  if (!galleryWrapper || galleryWrapper.hasAttribute('data-photoswipe-initialized')) {
    return;
  }

  // Disable WooCommerce's default lightbox by removing event handlers
  // This prevents WooCommerce's PhotoSwipe from interfering
  const disableWooCommerceLightbox = () => {
    // Remove all event listeners from gallery images and trigger
    const galleryImages = galleryWrapper.querySelectorAll('.woocommerce-product-gallery__image a');
    const galleryTrigger = galleryWrapper.querySelector('.woocommerce-product-gallery__trigger');
    
    // Clone elements to remove event listeners
    galleryImages.forEach((link) => {
      const newLink = link.cloneNode(true);
      link.parentNode.replaceChild(newLink, link);
    });

    if (galleryTrigger) {
      const newTrigger = galleryTrigger.cloneNode(true);
      galleryTrigger.parentNode.replaceChild(newTrigger, galleryTrigger);
    }

    // Also prevent default behavior by intercepting clicks early
    if (galleryTrigger) {
      galleryTrigger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      }, true); // Use capture phase to run before WooCommerce handlers
    }

    galleryImages.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      }, true);
    });
  };

  // Wait a bit for WooCommerce to initialize, then disable it
  setTimeout(() => {
    disableWooCommerceLightbox();
    
    // Get all gallery image links after cleanup
    const galleryImageLinks = galleryWrapper.querySelectorAll('.woocommerce-product-gallery__image a');
    const galleryTrigger = galleryWrapper.querySelector('.woocommerce-product-gallery__trigger');
    
    if (galleryImageLinks.length === 0) {
      return;
    }

    // Prepare images data for PhotoSwipe
    const prepareGalleryImages = () => {
      const images = [];
      
      galleryImageLinks.forEach((link) => {
        const img = link.querySelector('img');
        if (!img) return;

        // Get full-size image URL
        let fullImageUrl = link.getAttribute('href');
        
        // If href is not a valid image URL, try data attributes
        if (!fullImageUrl || fullImageUrl.startsWith('#') || !fullImageUrl.match(/\.(jpg|jpeg|png|gif|webp|svg)/i)) {
          fullImageUrl = img.getAttribute('data-large_image') || 
                        img.getAttribute('data-src') ||
                        link.getAttribute('data-large_image') ||
                        img.src;
        }

        // Get dimensions from WooCommerce data attributes
        let width = img.getAttribute('data-large_image_width') || 
                   img.getAttribute('width') ||
                   img.naturalWidth ||
                   1200; // Default fallback

        let height = img.getAttribute('data-large_image_height') || 
                    img.getAttribute('height') ||
                    img.naturalHeight ||
                    800; // Default fallback

        // Convert to numbers
        width = parseInt(width, 10);
        height = parseInt(height, 10);

        // Get alt text
        const alt = img.getAttribute('alt') || '';

        if (fullImageUrl && width && height) {
          images.push({
            src: fullImageUrl,
            width: width,
            height: height,
            alt: alt
          });

          // Add PhotoSwipe data attributes to the link
          link.setAttribute('data-pswp-src', fullImageUrl);
          link.setAttribute('data-pswp-width', width);
          link.setAttribute('data-pswp-height', height);
        }
      });

      return images;
    };

    // Create PhotoSwipe gallery structure
    let pswpGallery = null;
    let pswpInitialized = false;
    let pswpInitializing = false;

    const initializePhotoSwipe = () => {
      if (pswpInitialized && pswpGallery) {
        return Promise.resolve(pswpGallery);
      }

      if (pswpInitializing) {
        // Wait for existing initialization
        return new Promise((resolve) => {
          const checkInterval = setInterval(() => {
            if (pswpInitialized && pswpGallery) {
              clearInterval(checkInterval);
              resolve(pswpGallery);
            }
          }, 50);
        });
      }

      pswpInitializing = true;

      // Create a container for PhotoSwipe links
      let pswpContainer = document.querySelector('.pswp-gallery-container');
      if (!pswpContainer) {
        pswpContainer = document.createElement('div');
        pswpContainer.className = 'pswp-gallery-container';
        pswpContainer.style.display = 'none';
        document.body.appendChild(pswpContainer);
      }

      // Clear and rebuild gallery links with PhotoSwipe data attributes
      pswpContainer.innerHTML = '';
      const images = prepareGalleryImages();
      
      images.forEach((image) => {
        const link = document.createElement('a');
        link.href = image.src;
        link.setAttribute('data-pswp-width', image.width);
        link.setAttribute('data-pswp-height', image.height);
        if (image.alt) {
          link.setAttribute('data-pswp-caption', image.alt);
        }
        pswpContainer.appendChild(link);
      });

      // Dynamically import PhotoSwipe
      return Promise.all([
        import('https://cdn.jsdelivr.net/npm/photoswipe@5.4.4/dist/photoswipe-lightbox.esm.js'),
        import('https://cdn.jsdelivr.net/npm/photoswipe@5.4.4/dist/photoswipe.esm.js')
      ]).then(([PhotoSwipeLightboxModule, PhotoSwipeModule]) => {
        const PhotoSwipeLightbox = PhotoSwipeLightboxModule.default || PhotoSwipeLightboxModule.PhotoSwipeLightbox;
        const PhotoSwipe = PhotoSwipeModule.default || PhotoSwipeModule.PhotoSwipe;

        // Initialize PhotoSwipe Lightbox
        const lightbox = new PhotoSwipeLightbox({
          gallery: '.pswp-gallery-container',
          children: 'a',
          pswpModule: PhotoSwipe,
          showHideAnimationType: 'zoom',
          bgOpacity: 0.9
        });

        lightbox.init();
        pswpGallery = lightbox;
        pswpInitialized = true;
        pswpInitializing = false;
        return lightbox;
      }).catch((error) => {
        console.error('Error loading PhotoSwipe:', error);
        pswpInitializing = false;
        return null;
      });
    };

    // Function to open PhotoSwipe
    const openPhotoSwipe = (startIndex = 0) => {
      initializePhotoSwipe().then((lightbox) => {
        if (lightbox) {
          lightbox.loadAndOpen(startIndex);
        }
      });
    };

    // Handle trigger button click
    if (galleryTrigger) {
      galleryTrigger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        // Find currently visible image index
        let indexToOpen = 0;
        const visibleImage = galleryWrapper.querySelector('.woocommerce-product-gallery__image:not([style*="display: none"]) img');
        if (visibleImage) {
          const visibleLink = visibleImage.closest('a');
          if (visibleLink) {
            galleryImageLinks.forEach((link, idx) => {
              if (link === visibleLink) {
                indexToOpen = idx;
              }
            });
          }
        }
        
        openPhotoSwipe(indexToOpen);
      }, false);
    }

    // Handle image link clicks
    galleryImageLinks.forEach((link, index) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        openPhotoSwipe(index);
      }, false);
    });

    galleryWrapper.setAttribute('data-photoswipe-initialized', 'true');
  }, 100); // Small delay to ensure WooCommerce has initialized
}

export {initProductGallery, initProductGalleryPhotoSwipe}